export default __webpack_public_path__ + "static/media/banner.2b51ea96.jpg";